import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import AppStatusSlice from './slices/AppStatusSlice';
import BasketSlice from './slices/BasketSlice';
import EventHelperSlice from './slices/EventHelperSlice';
import InitialDataSlice from './slices/InitialDataSlice';
import OrderSlice from './slices/OrderSlice';
import PaymentOptionsSlice from './slices/PaymentOptionsSlice';
import ProfileSlice from './slices/ProfileSlice';
import ProductLikesSlice from './slices/ProductLikesSlice';
import TrackingSlice from './slices/TrackingSlice';
import InterceptorMiddleware from './middleware/InterceptorMiddleware';
import RootReducerMiddleware from './middleware/RootReducerMiddleware';
import * as Sentry from '@sentry/react';
import { REDUX_STORE_SLICES } from '../services/exports/Constants';
import PaymentFlowSlice from './slices/PaymentFlowSlice';

let rehydrationComplete;

const rehydrationPromise = new Promise((resolve) => {
  rehydrationComplete = resolve;
});

export function rehydration() {
  return rehydrationPromise;
}

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    return action.type?.startsWith('initialData/') ? null : action;
  },
  stateTransformer: (state) => ({
    ...state,
    initialData: null,
  }),
});

const persistConfig = {
  key: 'root',
  storage,
};

export const reducersCombined = combineReducers({
  [REDUX_STORE_SLICES.INITIAL_DATA]: InitialDataSlice.reducer,
  [REDUX_STORE_SLICES.PROFILE]: ProfileSlice.reducer,
  [REDUX_STORE_SLICES.BASKET]: BasketSlice.reducer,
  [REDUX_STORE_SLICES.ORDER]: OrderSlice.reducer,
  [REDUX_STORE_SLICES.PAYMENT_FLOW]: PaymentFlowSlice.reducer,
  [REDUX_STORE_SLICES.PAYMENT_OPTIONS]: PaymentOptionsSlice.reducer,
  [REDUX_STORE_SLICES.PRODUCT_LIKES]: ProductLikesSlice.reducer,
  [REDUX_STORE_SLICES.APP_STATUS]: AppStatusSlice.reducer,
  [REDUX_STORE_SLICES.EVENT_HELPER]: EventHelperSlice.reducer,
  [REDUX_STORE_SLICES.TRACKING]: TrackingSlice.reducer,
});

const reducerPersisted = persistReducer(persistConfig, reducersCombined);

const configure = () =>
  configureStore({
    reducer: (state, actions) => RootReducerMiddleware(state, actions, reducerPersisted),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(InterceptorMiddleware),
    enhancers: [sentryReduxEnhancer],
  });

export const store = configure();
export const persistor = persistStore(store, null, () => {
  // this will be invoked after rehydration is complete
  rehydrationComplete();
});
